import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

const isProd = String(process.env.NODE_ENV).toLowerCase() === 'production';
if (isProd) {
  const noop = () => {};
  ['log', 'warn', 'error', 'info', 'debug', 'trace', 'group', 'groupCollapsed', 'groupEnd'].forEach((method) => {
    if (typeof console[method] === 'function') {
      console[method] = noop;
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));

const render = (Component) => {
  root.render(
    <React.StrictMode>
      <Component />
    </React.StrictMode>
  );
};

const isPreviewOnly = String(process.env.REACT_APP_PREVIEW_ONLY).toLowerCase() === 'true';

if (isPreviewOnly) {
  // Load only the Preview-only app in this build and redirect to /preview
  import('./PreviewOnlyApp').then(({ default: PreviewOnlyApp }) => {
    render(PreviewOnlyApp);
  });
} else {
  // Load the full application
  import('./App').then(({ default: App }) => {
    render(App);
  });
}